<template>
    <div
        class="z-999 sm:z-40  bg-white absolute w-full h-screen mx-auto sm:pl-16 lg:px-20 right-0 opacity-95"
    >
        <router-link to="/" class="right-0 absolute p-2">
            <img
                src="images/close.png"
                class="bg-el-right p-2 h-10 w-10 rounded-full"
            />
        </router-link>
        <div class="mt-10">
            <div class="grid grid-cols-1">
                <div class="p-4 pl-10 lg:pl-32 lg:p-32 py-10 text-left">
                    <h1
                        class="text-base text-color-1 font-montserrat font-semibold mb-6"
                    >
                        Bienvenue sur l'application Webmapping du Cadastre Solaire
                    </h1>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold mb-4"
                    >
                        Le cadastre solaire estime le potentiel mensuel et annuel de production électrique solaire sur les toitures des bâtiments de la zone urbaine.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold mb-4"
                    >
                        Ainsi, grâce à cet outil, tout utilisateur pourra profiter des informations en terme d’irradiation provenant sur les surfaces de toiture pour avoir une meilleure vision en termes de possibilités d’économie sur la facture électrique et d’autonomie à travers des installations solaires.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold mb-4"
                    >
                        Cliquez sur les boutons Plus et Moins pour zoomer et dézoomer la carte, cliquer sur les toits en couleur pour afficher l’information de chaque toiture.
                        <br>Merci d'attendre 30 secondes pour le chargement des toitures.

                    </p>
                    <h3  class="text-base text-color-1 font-montserrat font-semibold mb-2">
                        Comment utiliser cette application Webmapping
                    </h3>
                    <ul class="list-disc ml-6">
                        <li
                            class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold mb-1"
                        >
                            La fenêtre d’accueil donne les informations générales sur le cadastre solaire.
                        </li>
                        <li
                            class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold mb-1"
                        >
                            Le positionnement d’un bâtiment donné est obtenu en cliquant sur le bouton de localisation.
                        </li>
                        <li
                            class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold mb-1"
                        >
                            Le potentiel de production électrique est particulièrement fort sur les surfaces colorées en rouge.
                        </li>
                    </ul>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold my-4"
                    >
                        En cliquant sur un bâtiment, les informations sur le potentiel solaire apparaissent dans une nouvelle fenêtre, contenant des informations
                        générales et d’autres plus détaillées et techniques. Le rapport complet sur le potentiel du bâtiment peut être imprimé.

                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-semibold mb-4"
                    >
                        La carte indique les surfaces ayant une Irradiation élevée au niveau des toitures (notamment celles bien orientées et peu ombragées) et qui peuvent des installations solaires.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {}
};
</script>
